import { decamelizeKeys } from "humps";
import { xanyahApi } from "../constants";

export const createSale = (sale) =>
	xanyahApi.post<Sale>("v2/sales", decamelizeKeys({ sale }));

export const updateSale = (saleId, params) =>
	xanyahApi.patch<Sale>(`v2/sales/${saleId}`, decamelizeKeys(params));

export const getSales = (params) =>
	xanyahApi.get<Sale[]>("v2/sales", decamelizeKeys({ params }));

export const getSale = (id) => xanyahApi.get<Sale>(`v2/sales/${id}`);

export const getSaleProducts = (params) =>
	xanyahApi.get<SaleProduct[]>("v2/sale_products", decamelizeKeys({ params }));

export const getSalePayments = (params) =>
	xanyahApi.get<SalePayment[]>("v2/sale_payments", decamelizeKeys({ params }));

export const getSalesReport = (params: {
	storeId?: string;
	from: string;
	to: string;
}) => xanyahApi.get<Sale[]>("v2/sales/report", decamelizeKeys({ params }));

// Idempotent: a sale already invoiced gets its invoice back, not a new number.
export const issueInvoice = (saleId: string) =>
	xanyahApi.post<Invoice>(`v2/sales/${saleId}/invoice`);
